import { render, staticRenderFns } from "./Boundary.vue?vue&type=template&id=7197b108&scoped=true"
import script from "./Boundary.vue?vue&type=script&lang=js"
export * from "./Boundary.vue?vue&type=script&lang=js"
import style0 from "./Boundary.vue?vue&type=style&index=0&id=7197b108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7197b108",
  null
  
)

export default component.exports